module.exports = __webpack_public_path__ + "static/media/logo.59e80a9c.svg";